import { themeMappings as b } from "./generate-theme-variables.js";
const g = "ikp";
function j(s) {
  const t = {};
  for (const [o, n] of Object.entries(s)) {
    const a = b[o] || o, r = (i, f = []) => {
      for (const [p, e] of Object.entries(i)) {
        const c = [...f, p];
        if (typeof e == "object" && e !== null)
          r(e, c);
        else {
          const l = c.map((y) => y.replace(/([A-Z])/g, "-$1").toLowerCase()).join("-"), u = `--${g}-${a}-${l}`;
          t[u] = e;
        }
      }
    };
    r(n);
  }
  return t;
}
export {
  j as createCSSVariables
};
